import React, { useState } from 'react';
import { Layout, Menu, Avatar, Dropdown, Space, MenuProps } from 'antd';
import {
  DashboardOutlined,
  FileTextOutlined,
  MedicineBoxOutlined,
  FileDoneOutlined,
  BarChartOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import './MedicalFacilityLayout.css';

const { Header, Sider, Content, Footer } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

const MedicalFacilityLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);
  const [collapsed, setCollapsed] = useState(false);

  const menuItems: MenuItem[] = [
    {
      key: '/facility/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/facility/prescriptions',
      icon: <FileTextOutlined />,
      label: 'Quản lý đơn thuốc',
    },
    {
      key: '/facility/national-prescriptions',
      icon: <MedicineBoxOutlined />,
      label: 'Đơn thuốc quốc gia',
    },
    {
      key: '/facility/invoices',
      icon: <FileDoneOutlined />,
      label: 'Xuất hóa đơn',
    },
    {
      key: '/facility/statistics',
      icon: <BarChartOutlined />,
      label: 'Thống kê',
    },
    {
      key: '/facility/config',
      icon: <SettingOutlined />,
      label: 'Cấu hình',
      children: [
        {
          key: '/facility/config/clinic',
          label: 'Cấu hình phòng khám',
        },
        {
          key: '/facility/config/api',
          label: 'Cấu hình API toa thuốc',
        },
        {
          key: '/facility/config/doctors',
          label: 'Danh sách bác sĩ',
        },
      ],
    },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Đăng xuất',
    },
  ];

  const handleUserMenuClick = ({ key }: { key: string }) => {
    if (key === 'logout') {
      handleLogout();
    }
  };

  return (
    <Layout className="main-layout">
      <Header className="main-header">
        <div className="header-left">
          <div className="logo-container">
            <div className="logo-icon-small">O</div>
            <span className="logo-text">OMECAP HUB - ĐƠN THUỐC QUỐC GIA</span>
          </div>
        </div>
        <div className="header-right">
          <Dropdown menu={{ items: userMenuItems, onClick: handleUserMenuClick }} placement="bottomRight">
            <Space className="user-info">
              <Avatar icon={<UserOutlined />} />
              <span>{user ? `${user.first_name} ${user.last_name}`.trim() || user.username : 'Admin'}</span>
            </Space>
          </Dropdown>
        </div>
      </Header>
      <Layout>
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          width={250}
          className="main-sider"
        >
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={handleMenuClick}
            className="main-menu"
          />
        </Sider>
        <Layout>
          <Content className="main-content">
            <Outlet />
          </Content>
          <Footer className="main-footer">
            Copyright Omecap © 2025
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MedicalFacilityLayout;

